<template>
  <div class="yunxiao teacher schedule full-page" data-test="schedule">
    <div class="top-nav"></div>
    <schedule-calendar
      :eventDays="eventDays"
      :defaultDate="defaultDate"
      @chooseDate="dayChangeHandler"
      @monthChange="monthChangeHandler"
    >
      <template v-slot:moreBtns>
        <div
          class="switch-type-btns"
          :class="{ 'show-all-course': !showMineOnly }"
          v-if="app.permission.op('course_arrange_teacher  && all_course_arrange')"
        >
          <div :class="{ active: showMineOnly }" @click="!showMineOnly && showMineOnlyHandler()">
            我的课表
          </div>
          <div :class="{ active: !showMineOnly }" @click="showMineOnly && showMineOnlyHandler()">
            全部课表
          </div>
        </div>
        <div v-else class="switch-type-btns show-mine-only" @click="showMineOnlyHandler">
          <div class="active">
            {{ showMineOnly ? '我的课表' : '全部课表' }}
          </div>
        </div>
      </template>
      <template v-slot:rightBtns>
        <div style="display: flex; align-items: baseline">
          <div
            class="filter-btns"
            :class="{ flitering: hasFilter }"
            @click="openFilter"
            data-test="schedule-btn-filter"
          >
            <van-icon class-prefix="vxs-icon" name="shaixuan1" />
          </div>

          <van-popover
            v-model="showPopover"
            placement="bottom-end"
            @closed="tipsPopoverClose"
            :offset="[10, 8]"
            :close-on-click-overlay="false"
            :close-on-click-outside="false"
            :get-container="getContainer"
            theme="dark"
          >
          <template #reference>
            <van-popover placement="bottom-end" v-model="showMore" trigger="click" :offset="[12, 8]">
              <div class="search-filter-more-popover">
                <div
                  class="more-item"
                  @click="showMore = false,$router.push('/course-attend-statistics')"
                >
                  <van-icon
                    class="icon"
                    class-prefix="vxs-icon"
                    size="24"
                    color="var(--g8)"
                    name="zhuzhuangshuju"
                  ></van-icon>
                  <span class="more-item-text">上课统计</span>
                </div>
                <div
                  class="more-item"
                  v-if="app.permission.op('all_course_arrange || course_arrange_teacher')"
                  @click="showMore = false,toPaikeList()"
                >
                  <van-icon
                    class="icon"
                    class-prefix="vxs-icon"
                    size="24"
                    color="var(--g8)"
                    name="kebiaoguanli"
                  ></van-icon>
                  <span class="more-item-text">排课管理</span>
                </div>
              </div>
              <template #reference>
                <div class="filter-btns">
                  <van-icon
                    class-prefix="vxs-icon"
                    name="gengduo1"
                    size="24"
                    color="var(--g8)"
                  ></van-icon>
                </div>
              </template>
            </van-popover>
          </template>
          <template>
              <div class="list-entry-tips-div">
                <van-icon name="cross" @click.stop="showPopover = false" />
                <div class="tips-contain">
                  点击这里体<br/>验更多功能
                </div>
              </div>
            </template>
          </van-popover>
        </div>
      </template>
    </schedule-calendar>

    <div class="event-container">
      <!-- <van-loading type="spinner" v-if="courseLoading" size="16px"> 加载中... </van-loading> -->

      <template v-if="courseData.length > 0 && courseData[0].courseArrangeRecordVos.length > 0">
        <van-pull-refresh v-model="courseLoading" @refresh="getDayData">
          <eventList :infos="courseData[0]" />
        </van-pull-refresh>
      </template>
      <div v-else-if="!courseLoading" class="empty-page-nav">
        <empty-page :show="!courseLoading" :tips="''">
          <div v-if="app.permission.op('add_course_arrange')" style="text-align: center">
            未提前排课？直接
            <span style="color: var(--tlc)" @click="$router.push('/classPaiKeAdd?isQuick=1')"
              >快速排课点名</span
            >
          </div>
          <div v-else>没有数据</div>
        </empty-page>
      </div>
    </div>
  </div>
</template>
<script>
import scheduleCalendar from '@x3/vue/comp/schedule-calendar.vue';
import eventList from './eventList.vue';
import emptyPage from '@teacher/components/empty-page.vue';

import { openScheduleFiltrate } from './filtrate/index.js';

const readLsKeyName = 'schedule-index-20221212';

export default {
  name: 'classSchedule',
  components: {
    scheduleCalendar,
    eventList,
    emptyPage,
  },
  data() {
    let { query = {} } = this.$vxRoute;
    let initDate = query.date ? new Date(query.date) : new Date();
    return {
      pageTitle: '课表',
      showMore: false,
      // 选中天
      choosedDate: initDate,
      // 默认显示天
      defaultDate: new Date(initDate.getTime()),
      // 选中月
      currentMonth: app.tool.date.formatDatetime(new Date(initDate.getTime()), 'yyyy-MM'),
      filterParams: {
        // 校区Ids
        campusIds: [],
        campusList: [],
        // 选中的老师id数组
        teacherIds: query.tId ? [query.tId] : [],
        courseOrAssistantTeacherIds: [app.teacher.user.id],
        teacherList: [],
        studentIds: [],
        studentList: [],
        classId: '',
        curriculumId: '',
        curriculumName: '',
        classRoomIds: query.rId ? [query.rId] : [],
        classRoomList: [],
        assistantTeacherIds: [],
        classStatusList: [0],
      },

      // 有课的天数集合
      eventDays: [],
      courseData: [],

      courseLoading: false,
      showMineOnly: !query.showAll,

      showPopover: false,
      isok: false
    };
  },
  computed: {
    // 当前是否有筛选
    hasFilter() {
      let {
        campusIds,
        teacherIds,
        studentIds,
        classId,
        curriculumId,
        classRoomIds,
        assistantTeacherIds,
      } = this.filterParams;
      if (
        campusIds.length ||
        (teacherIds.length && !this.showMineOnly) ||
        studentIds.length ||
        classRoomIds.length ||
        (assistantTeacherIds.length && !this.showMineOnly)
      ) {
        return true;
      }
      if (classId || curriculumId) {
        return true;
      }
      return false;
    },
    queryFilterParams () {
      let params = {...this.filterParams};
      delete params.teacherList;
      delete params.studentList;
      delete params.classRoomList;
      if (this.showMineOnly) {
        delete params.teacherIds;
        delete params.assistantTeacherIds;        
      }
      return params;
    }
  },
  methods: {
    // 按月获取本月需上课情况
    async getMonthData() {
      let res = await this.$api.getMonthCourse({
        date: this.currentMonth,
        ...this.queryFilterParams,
      });
      if (res.code === 200) {
        this.eventDays = res.data;
      }
      return res;
    },
    // 按天获取课表
    async getDayData() {
      this.courseLoading = true;
      try {
        if (this._cp) {
          try {
            this._cp.cancel();
          } catch (err) {
            console.log('取消上次计算了');
          }
        }
        this._cp = this.$api.getCompanyCourse({
          date: app.tool.date.formatDatetime(this.choosedDate, 'yyyy-MM-dd'),
          ...this.queryFilterParams,
        });
        let res = await this._cp;
        if (res.code === 200) {
          this.courseData = res.data;
        }
        this.courseLoading = false;
        return res;
      } catch (err) {
        this.courseLoading = false;
        return Promise.reject(err);
      }
    },
    // 切换月
    monthChangeHandler(val) {
      this.currentMonth = val;
    },
    // 切换日
    dayChangeHandler(val) {
      this.choosedDate = val;
    },
    // 打开筛选
    async openFilter() {
      let res = await openScheduleFiltrate({
        params: {
          ...this.filterParams,
          assitantsList: this.assitantsList,
        },
        config: {
          showTeacher: !this.showMineOnly,
          showAssitants: !this.showMineOnly,
          showMineOnly: this.showMineOnly,
        },
      });

      this.filterParams.studentIds = res.params.studentIds;
      this.filterParams.studentList = res.params.studentList;
      this.filterParams.campusIds = res.params.campusIds;
      this.filterParams.campusList = res.params.campusList;
      this.filterParams.teacherIds = res.params.teacherIds;
      this.filterParams.teacherList = res.params.teacherList;
      this.filterParams.classId = res.params.classId;
      this.filterParams.classIds = [res.params.classId];
      this.filterParams.className = res.params.className;
      this.filterParams.curriculumId = res.params.curriculumId;
      this.filterParams.curriculumName = res.params.curriculumName;
      this.filterParams.startDate = res.params.startDate;
      this.filterParams.endDate = res.params.endDate;
      this.filterParams.classRoomIds = res.params.classRoomIds;
      this.filterParams.classRoomList = res.params.classRoomList;
      this.filterParams.assistantTeacherIds = res.params.assistantTeacherIds;
      this.filterParams.classStatusList = res.params.classStatusList;
      this.assitantsList = res.params.assitantsList;
    },
    showMineOnlyHandler() {
      if (!app.permission.op('course_arrange_teacher && all_course_arrange')) return false;
      let { showMineOnly } = this;
      if (showMineOnly) {
        this.showMineOnly = false;
        this.filterParams.courseOrAssistantTeacherIds = [];
        this.$toast('已切换为全部课表');
      } else {
        this.showMineOnly = true;
        this.filterParams.courseOrAssistantTeacherIds = [app.teacher.user.id];
        this.$toast('已切换为我的课表');
      }
    },
    async getAllDatas() {
      this.showLoading();

      let ajax = Promise.all([this.getMonthData(), this.getDayData()]);
      try {
        await ajax;
      } catch (err) {
        console.log(err);
      }
      this.isok = true;
      this.$toast.clear();
    },
    tipsPopoverClose() {
      app.ls.setStorage(readLsKeyName, new Date());
    },
    toPaikeList() {
      this.showPopover = false;
      let { showMineOnly } = this;
      if (showMineOnly) {
        this.$router.push(`/paikeList?onlyMy=${Number(showMineOnly)}`);
      } else {
        this.$router.push(`/paikeList?onlyMy=${Number(showMineOnly)}`);
      }
    },
    getContainer() {
      return this.$el;
    },
  },
  async created() {
    let { query = {} } = this.$vxRoute;
    if (query.rId) {
      this.filterParams.classRoomList = [{ id: query.rId, roomName: query.rName }];
      this.filterParams.campusIds = [query.cId];
      this.filterParams.teacherIds = [];
      this.filterParams.teacherList = [];
      this.filterParams.campusList = [{ id: query.cId, name: query.cName }];
    }
    if (query.tId) {
      this.filterParams.teacherList = [{ id: query.tId, name: query.tName }];
    }
    // 如果初始默认为全部课表
    if (!this.showMineOnly) {
       this.filterParams.courseOrAssistantTeacherIds = [];
    }
    if (!app.permission.op('course_arrange_teacher') && app.permission.op('all_course_arrange')) {
      this.showMineOnly = false;
      this.filterParams.courseOrAssistantTeacherIds = [];
    } else {
      this.getAllDatas();
    }

    this.$onBus('course-arrange-delete-success', this.getAllDatas);


    // 判断是否展示排课管理入口移动测试
    // 添加延迟效果会好些
    setTimeout(() => {
      this.showPopover =
        !app.ls.getStorage(readLsKeyName) && app.permission.op('all_course_arrange');
    }, 500);
    // alert(app.ls.getStorage(readLsKeyName))
  },
  vxshow(){
    if (!this.isok) {
      return;
    }
    this.getAllDatas();
  },

  watch: {
    currentMonth(nv, ov) {
      this.getMonthData();
    },
    choosedDate(nv, ov) {
      this.getDayData();
    },
    filterParams: {
      deep: true,
      handler: function (nv, ov) {
        this.getMonthData();
        this.getDayData();
      },
    },
  },
};
</script>

<style lang="scss">
.yunxiao.teacher.schedule {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .event-container {
    position: relative;
    padding-bottom: calc(var(--gap) * 32);
    flex: 1;
    overflow-y: auto;
    .van-loading {
      margin-top: calc(var(--gap) * 16);
      text-align: center;
    }
  }
  .filter-btns {
    background: var(--g1);
    border-radius: 50%;
    width: 32px;
    height: 32px;
    margin-left: calc(var(--gap) * 12);
    display: flex;
    justify-content: center;
    align-items: center;
    &.flitering .vxs-icon {
      color: var(--c1);
    }
    .vxs-icon {
      font-size:calc(var(--fs-xs) * 2.4);
      color: var(--g8);
    }
  }
  .empty-page-nav {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow-y: auto;
    > div {
      position: static;
    }
    .data-null {
      margin-top: calc(var(--gap) * 60);
      position: static;
      transform: unset;
    }
    > span {
      position: absolute;
      color: var(--tlc);
      top: 12px;
      right: 16px;
      z-index: 100;
    }
  }
  .switch-type-btns {
    position: relative;
    display: flex;
    height: calc(var(--w) * 56);
    font-size:var(--fs-lg);
    line-height:var(--lh-lg);
    font-weight: 400;
    color: var(--g8);
    > div {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      color: var(--g6);
      &:not(:last-child) {
        margin-right: calc(var(--gap) * 16);
      }
      &.active {
        font-weight: var(--bold);
        color: var(--g8);
      }
    }
  }
  .show-mine-only {
    margin-right: calc(var(--gap) * 16);
    font-size: var(--fs-lg);
    font-weight: var(--bold);
    white-space: nowrap;
  }
  .switch-type-btns,
  .show-mine-only {
    position: relative;
    z-index: 1;
    &::before {
      position: absolute;
      content: '';
      display: block;
      margin-left: calc(var(--gap) * -4);
      left: 25%;
      bottom: 0px;
      width: calc(var(--w) * 20);
      height: calc(var(--w) * 4);
      background: var(--c1);
      border-radius: calc(var(--radius-base) * 0.5);
      transform: translateX(-50%);
      transition: left 0.2s ease-in;
    }
  }
  .show-mine-only:before {
    margin-left: unset;
    left: 50%;
  }
  .show-all-course.switch-type-btns::before {
    margin-left: calc(var(--gap) * 4);
    left: 75%;
  }
  .van-popover__arrow {
    right: calc(var(--w) * 14) !important;
  }
}

.list-entry-tips-div {
  display: flex;
  padding: calc(var(--gap) * 12) calc(var(--gap) * 12) calc(var(--gap) * 8) calc(var(--gap) * 10);
  width: calc(var(--w) * 178);
  box-sizing: border-box;
  font-size: var(--fs-md);
  line-height: var(--lh-md);
  font-weight: var(--bold);
  color: var(--white);
  align-items: center;

  .van-icon {
    padding-right: calc(var(--gap) * 12);
  }
  &::after {
    margin: calc(var(--gap) * -4) 0 0 calc(var(--gap) * 14);
    content: '';
    display: block;
    width: calc(var(--w) * 29);
    height: calc(var(--w) * 45);
    background: transparent url(https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/0090.png)
      no-repeat;
    background-size: cover;
  }
}

.search-filter-more-popover {
  padding: 0 calc(var(--gap) * 16);
  .more-item {
    position: relative;
    display: flex;
    align-items: center;
    font-size: var(--fs-md);
    line-height: var(--lh-md);
    color: var(--g8);
    height: calc(var(--gap) * 42);
    .icon {
      font-weight: var(--bold);
    }
    .more-item-text {
      margin-left: calc(var(--gap) * 8);
    }
    &:not(:last-child)::after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 1px;
      transform: scaleY(0.5);
      z-index: 10;
      background-color: var(--g3);
    }
  }
}
</style>
